import { Component, Prop, h } from '@stencil/core';

import { actions } from '../../../actions/actions.interactive-banner';
import { BannerStep, bannerSizeType } from '../../../utils/utils.interactive-banner';

@Component({
  tag: 'banner-review-inspection',
  styleUrl: 'banner-review-inspection.css',
})
export class BannerReviewInspection {
  @Prop() yearId: number;
  @Prop() make: string = '';
  @Prop() model: string = '';
  @Prop() trim: string = '';
  @Prop() bannerStatus: BannerStep = BannerStep.Review;
  @Prop() bannerReviewInspectionSize: bannerSizeType = 'large';

  viewCertificate() {
    actions.viewOfferCertificate();
  }

  render() {
    const textLink = 'Start a New Offer';
    const carName = `${this.yearId} ${this.make} ${this.model} ${this.trim}`;
    let title = 'Your Offer Is In Review';
    let description = 'Reviews usually take 3-5 minutes.';
    if (this.bannerStatus === BannerStep.Inspection) {
      title = 'Inspection Required';
      description = 'To confidently give you an Instant Cash Offer, we need to see your vehicle. Please call this Participating Dealer to make an appointment.';
    }

    const bannerWarningBlockClass = {
      'banner-review-block': true,
      'flex-col py-4': this.bannerReviewInspectionSize !== 'large',
      'box-border h-130': this.bannerReviewInspectionSize === 'large',
    };

    const containContentClass = {
      'mb-4': this.bannerReviewInspectionSize !== 'large',
      'mt-4': this.bannerReviewInspectionSize === 'small' || this.bannerReviewInspectionSize === 'xsmall',
      'text-center flex flex-col justify-center': this.bannerReviewInspectionSize === 'large',
    };

    const containTitleClass = {
      'mb-2': this.bannerReviewInspectionSize !== 'large',
      'mt-2': this.bannerReviewInspectionSize === 'xsmall',
    };
    const titleClass = {
      'banner-review-title': true,
      'text-left': this.bannerReviewInspectionSize === 'medium',
    };

    const bannerContainResetClass = {
      'flex items-end': this.bannerReviewInspectionSize === 'medium',
      hidden: this.bannerReviewInspectionSize === 'small' || this.bannerReviewInspectionSize === 'xsmall',
    };

    const bannerResetClass = {
      'basis-13p flex flex-col': true,
      'items-center': this.bannerReviewInspectionSize === 'small' || this.bannerReviewInspectionSize === 'xsmall',
      'items-reverse': this.bannerReviewInspectionSize !== 'small' && this.bannerReviewInspectionSize !== 'xsmall',
    };

    const bannerKBBLogoWithLinkClass = {
      'basis-full': this.bannerReviewInspectionSize !== 'large',
      'pt-0': true,
    };

    const bannerLogoClass = {
      'flex items-center': this.bannerReviewInspectionSize === 'large',
      absolute: this.bannerReviewInspectionSize === 'medium',
    };

    const subContent = {
      'text-xs/4 text-left': true,
    };

    const logoAndContentClass = {
      'flex flex-row flex-row-reverse justify-between': this.bannerReviewInspectionSize === 'medium',
      'flex flex-row justify-between': this.bannerReviewInspectionSize === 'large',
    };

    const viewCertificateAndResetClass = {
      'flex flex-col-reverse justify-between': this.bannerReviewInspectionSize === 'large',
      'flex flex-row justify-between': this.bannerReviewInspectionSize === 'medium',
      'flex flex-row': this.bannerReviewInspectionSize === 'small',
      'min-w-250 pb-3 pt-1.5': this.bannerReviewInspectionSize === 'large',
    };

    const containSubcontentClass = {
      'w-1/2': this.bannerReviewInspectionSize === 'medium',
    };

    const containDescriptionClass = {
      'w-1/2': this.bannerReviewInspectionSize === 'medium',
    };

    return (
      <div class={bannerWarningBlockClass}>
        <div class={logoAndContentClass}>
          <div class={bannerLogoClass}>
            <banner-logo
              textLink={textLink}
              hiddenOnMobile={false}
              txtLinkHiddenOnDesktop={true}
              showDesktop={this.bannerReviewInspectionSize === 'large'}
              class={bannerKBBLogoWithLinkClass}
              hiddenReset={this.bannerReviewInspectionSize !== 'small' && this.bannerReviewInspectionSize !== 'xsmall'}
              textResetSize="sm"
              logoWithMPTop={false}
            />
          </div>
        </div>
        <div class={containContentClass}>
          <div class={containTitleClass}>
            <h1 class={titleClass}>{title}</h1>
          </div>

          <div class={containSubcontentClass}>
            <span class={subContent}>Your vehicle:</span>
            <p class="mt-0 mb-0 font-semibold font-open-sans">{carName}</p>
          </div>
          <div class={containDescriptionClass}>
            <span class="text-sm block mt-1">{description}</span>
            {this.bannerStatus === BannerStep.Review && <span class="text-xs/4">A representative is reviewing your Offer. We'll send you an email when we have an update.</span>}
          </div>
        </div>
        <div class={viewCertificateAndResetClass}>
          <div>
            <ico-button
              label="View Offer Certificate"
              buttonSize={this.bannerReviewInspectionSize === 'xsmall' ? 'xsmall' : 'xmedium'}
              buttonStyle="tertiary-secondary"
              whenClicked={() => {
                this.viewCertificate();
              }}
            />
          </div>
          <div class={bannerContainResetClass}>
            <banner-reset textLink={textLink} showDesktop={this.bannerReviewInspectionSize === 'large'} class={bannerResetClass} textResetSize="sm" />
          </div>
        </div>
      </div>
    );
  }
}
